<template>
  <section id="shopping">
    <Join :workspaceJoinId="workspaceJoinId" />
  </section>
</template>

<script>
import _ from 'lodash';
import Join from '../../components/Join/Join.vue';

export default {
  components: {
    Join,
  },
  data() {
    return {
      workspaceJoinId: null,
    };
  },
  created() {
    this.workspaceJoinId = _.get(this.$route.params, 'workspaceId', null);
  },
};
</script>

<style lang="scss" scoped src="./Join.scss"></style>
